/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React                     from 'react';
import PropTypes                 from 'prop-types';
import { StyledInlineMessage }   from '../../atoms/StyledInlineMessage';
import { StyledMessageWithIcon } from '../../atoms/StyledMessageWithIcon';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const MessageWithIcon = ({ icon, children }) => (
    <StyledMessageWithIcon>
        {icon}
        <StyledInlineMessage>{children}</StyledInlineMessage>
    </StyledMessageWithIcon>
);

MessageWithIcon.propTypes = {
    icon: PropTypes.element,
    children: PropTypes.node
};



// WEBPACK FOOTER //
// ./src/components/molecules/MessageWithIcon/index.js